import {
  ComponentType,
  Context,
  Direction,
  Size,
  VisualStyle,
  FontWeight,
} from 'data-types-config';
import type { InteractiveArchetypeProps } from './InteractiveArchetype.types';

export const placeholderInteractiveArchetype: InteractiveArchetypeProps = {
  ariaLabel: 'Some Label',
  componentType: ComponentType.Interactive,
  context: Context.Primary,
  direction: Direction.Right,
  isBlock: false,
  isDisabled: false,
  size: Size.Medium,
  text: 'Some Descriptive Text',
  visualStyle: VisualStyle.Highlighted,
  fontWeight: FontWeight.Bold,
};

export const placeholderInteractiveArchetypeList: InteractiveArchetypeProps[] = [
  {
    text: 'Submit',
    context: Context.Secondary,
    size: Size.Small,
  },
  {
    text: 'Learn More',
    context: Context.Primary,
    size: Size.Large,
    visualStyle: VisualStyle.Underlined,
  },
];
